import { useContext, useMemo } from 'react';
import { UserType } from '../../../graphql/types';
import { UserTypeContext } from '../../../UserTypeContext';
import { useEnumStrings } from '../../enumStrings';

// Wave C ACON-4 (MD-30, Member Dashboard design ACC:L676-904): the member's
// Create / Update Company Perks wording. Chamber staff use the same pages
// for a member's perks, so the design text applies only to member logins.

export const MEMBER_CREATE_PERK_COPY = {
  pageTitle: 'Create Company Perks',
  pageSubtitle: 'Create your company perk on our Chamber Perks App™ and website directories. Watch video or view instructions to learn how.',
  perkDescriptionPlaceholder: 'Enter Perk Details',
  perkRedemptionAvailabilityHelperText: 'Choose a recurring perk to reward and retain loyal customers with benefits they can redeem multiple times, while a one-time perk is designed to attract new customers by offering a single, exclusive incentive for initial engagement.',
  contactCompanyDesc: 'Select this option if users must contact the company directly (by phone, email, or message) to redeem perk.',
  forOnlinePerkRedemptions: 'For Online Perk Redemptions',
  sendNewPerkNotificationHelperText: 'Keep this enabled so users can be notified when a new perk is created.',
  downloadImportCsvSample: 'Download Import CSV Sample',
  emailsWillAppear: 'Enter Employees Email',
  importantNote: 'IMPORTANT NOTE: EMAILS CAN BE REMOVED AND EMPLOYEE WILL NO LONGER BE ABLE TO VIEW OR REDEEM COMPANY EMPLOYEE PERKS.',
  createMemberPerkButton: 'Create Perk',
  localMembersDesc: 'This perk can be viewed and redeemed only by companies and their employees who are members of your local Chamber Commerce or Board of Trade',
  employeesOnlyDesc: 'This perk can be viewed and redeemed only by the employees authorized from the company. (Employees MUST download the Chamber Perks App™ and share their email used to set up their personal user account to be able to view and redeem.',
  idaTitleModalTitle: 'Let Me Generate Your Perk Title',
  idaDescModalTitle: 'Let Me Generate Your Perk Description',
  idaDescGeneratedLabel: 'Perk description generated by IDA:',
  idaPerkDescriptionLabel: 'Perk description generated by IDA:',
};

export const MEMBER_UPDATE_PERK_COPY = {
  pageTitle: 'Update Perk',
  pageSubtitle: MEMBER_CREATE_PERK_COPY.pageSubtitle,
  sendUpdatedPerkNotification: 'Send New Perk Notification',
  updateMemberPerkButton: 'Update Perk',
};

export const MEMBER_PERK_VALIDATION_COPY = {
  perkTitleIsRequired: 'Perk title is required. Please enter a title for your perk.',
  perkDescriptionIsRequired: 'Perk description is required. Please enter a description for your perk.',
};

/** useEnumStrings with the design's member wording on the perk pages. */
export const useMemberPerkStrings = () => {
  const enumStrings = useEnumStrings();
  const { state: { userType } } = useContext(UserTypeContext);
  return useMemo(() => (userType !== UserType.ChamberMemberAdmin ? enumStrings : {
    ...enumStrings,
    createPerk: { ...enumStrings.createPerk, ...MEMBER_CREATE_PERK_COPY },
    updateMemberPerk: { ...enumStrings.updateMemberPerk, ...MEMBER_UPDATE_PERK_COPY },
    validation: { ...enumStrings.validation, ...MEMBER_PERK_VALIDATION_COPY },
  }), [enumStrings, userType]);
};
